import { render } from "./Paramedie.vue?vue&type=template&id=272d056a"
import script from "./Paramedie.vue?vue&type=script&lang=js"
export * from "./Paramedie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__